import React, { useEffect, useState } from 'react';
import {
    Button,
    Box,
    Typography,
    Paper,
    styled,
    LinearProgress,
    IconButton,
    Grid,
    Select,
    InputLabel,
    FormControl,
    MenuItem,
    Snackbar,
    Alert,
    Backdrop,
    CircularProgress,
    Divider,
    InputAdornment,
    Tooltip,
} from '@mui/material';
import { Close, CloudUpload, Save, RestartAlt, Route, InsertPhoto } from "@mui/icons-material";
import { AdminPage, SectionTitle, GREEN, LIGHT, BORDER, primaryButtonSx, subCardSx } from '../admin/AdminPageLayout';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { travel_admin, update_img_route_banner, upload_image_all } from '../api/API';

// สร้าง input component ที่ซ่อนอยู่
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});



function MainEditImageInfographic() {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const uid = decoded?.uid || decoded?.user_id || null;

    const [travelRoute, setTravelRoute] = useState([]);
    const [idTravelRouteImg, setIDTravelRouteImg] = useState("");
    const [images, setImages] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [progress, setProgress] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error" | "warning" | "info"

    const [errorSnackbar, setErrorSnackbar] = useState({
        open: false,
        message: "",
    });

    // ✅ โหลดเส้นทางทั้งหมด
    useEffect(() => {
        const fetchTravelRoute = async () => {
            if (!token) return;
            setInitialLoading(true);
            try {
                const res = await axios.get(travel_admin, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setTravelRoute(res.data || []);

            } catch (error) {
                console.error("โหลดเส้นทางล้มเหลว:", error);
                alert("❌ โหลดข้อมูลเส้นทางล้มเหลว");
            } finally {
                setInitialLoading(false);
            }
        };
        fetchTravelRoute();
    }, [token]);

    console.log("idTravelRouteImg", idTravelRouteImg);

    // ✅ เมื่อเปลี่ยนเส้นทาง
    const handleTravelChangeImg = (e) => {
        setIDTravelRouteImg(e.target.value);
    };

    const handleImageUpload = (e, type) => {
        console.log("e", e);

        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const newImages = files.map((file) => ({
                type,
                file,
                name: file.name,
                preview: URL.createObjectURL(file),
            }));

            const otherImages = images.filter((img) => img.type !== type);
            setImages([...otherImages, ...newImages]);
        }
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };


    const handleRemoveImage = (type, indexToRemove) => {
        // ลบเฉพาะภาพในกลุ่ม type นั้น ๆ
        const updatedImages = images?.filter((img, index) => {
            if (img.type !== type) return true; // เก็บไว้ถ้าคนละ type
            // ถ้า type เดียวกัน ให้ลบเฉพาะตัวที่ตรง index ของกลุ่มนั้น
            const sameTypeImages = images?.filter((i) => i.type === type);
            const targetImage = sameTypeImages[indexToRemove];
            return img !== targetImage;
        });

        setImages(updatedImages);
    };

    // ✅ ฟังก์ชันอัปโหลด
    const handleSubmit = async () => {
        if (!idTravelRouteImg) {
            alert("กรุณาเลือกเส้นทางก่อนอัปโหลด");
            return;
        }

        try {
            setUploading(true);
            setProgress(0);

            const newRouteId = idTravelRouteImg;
            const types = [...new Set(images.map((img) => img.type))];
            const uploadedPaths = [];

            for (const type of types) {
                const imagesOfType = images.filter((img) => img.type === type);
                if (imagesOfType.length === 0) continue;

                const formDataUpload = new FormData();
                imagesOfType.forEach((img) => {
                    formDataUpload.append("files", img.file);
                });

                formDataUpload.append("media_type", "image");
                formDataUpload.append("type", type);
                formDataUpload.append("place_type", "route");
                formDataUpload.append("ref_id", newRouteId);
                formDataUpload.append("ref_name", "route");

                console.log("Uploading images for type:", type, imagesOfType.length);

                const uploadRes = await axios.post(upload_image_all, formDataUpload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent) => {
                        const percent = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setProgress(percent);
                    },
                });
                console.log("uploadRes", uploadRes);

                const results =
                    uploadRes?.data?.data?.results ||
                    uploadRes?.data?.results ||
                    [];

                if (Array.isArray(results) && results.length > 0) {
                    const paths = results.map((r) => r.file_path);
                    uploadedPaths.push(...paths);
                    console.log("📸 Uploaded paths:", paths);
                } else {
                    console.warn("⚠️ Upload response format unexpected:", uploadRes.data);
                    // ✅ ไม่ต้อง throw error ทันที ให้แค่แจ้งเตือน
                    setErrorSnackbar({
                        open: true,
                        message: `⚠️ การอัปโหลด ${type} สำเร็จ แต่ไม่พบ path ใน response`,
                        severity: "warning",
                    });
                }
            }

            console.log("uploadedPaths ++++++", uploadedPaths);

            if (uploadedPaths.length > 0) {
                setErrorSnackbar({
                    open: true,
                    message: "✅ อัปโหลดรูปภาพสำเร็จ!",
                    severity: "success",
                });
                console.log("Uploaded paths:", uploadedPaths);
            } else {
                setErrorSnackbar({
                    open: true,
                    message: "❌ ไม่มีรูปใดถูกอัปโหลดสำเร็จ",
                    severity: "error",
                });
            }

            // ✅ Reset ค่าหลังอัปโหลดสำเร็จ
            setImages([]);
            setProgress(0);
        } catch (error) {
            console.error("Upload error:", error);
            setErrorSnackbar({
                open: true,
                message: `❌ อัปโหลดล้มเหลว: ${error.message}`,
                severity: "error",
            });
        } finally {
            setUploading(false);
        }
    };

    const infoImages = images.filter((img) => img.type === "info_route");

    return (
        <>
            <AdminPage
                icon={<InsertPhoto fontSize="large" />}
                title="แก้ไขรูปภาพอินโฟกราฟิก"
                subtitle="เลือกเส้นทาง แล้วอัปโหลดรูปภาพอินโฟกราฟิกใหม่"
                actions={
                    <>
                        <Button
                            variant="outlined"
                            color="inherit"
                            startIcon={<RestartAlt />}
                            onClick={handleRemoveImage}
                            disabled={uploading}
                            sx={{ borderRadius: 3, width: { xs: "100%", sm: "auto" }, color: "text.secondary", borderColor: "#ccc" }}
                        >
                            ยกเลิก
                        </Button>
                        <Button
                            variant="contained"
                            size="large"
                            startIcon={uploading ? <CircularProgress size={18} color="inherit" /> : <Save />}
                            onClick={handleSubmit}
                            disabled={uploading}
                            sx={primaryButtonSx}
                        >
                            {uploading ? 'กำลังบันทึก...' : 'บันทึก'}
                        </Button>
                    </>
                }
            >
                {/* ① เลือกเส้นทาง */}
                <SectionTitle step={1} title="เลือกเส้นทาง" />
                <FormControl fullWidth disabled={uploading}>
                    <InputLabel id="travel-route-select-img-label">เลือกเส้นทาง</InputLabel>
                    <Select
                        labelId="travel-route-select-img-label"
                        id="travel-route-select-img"
                        value={idTravelRouteImg}
                        label="เลือกเส้นทาง"
                        onChange={handleTravelChangeImg}
                        color="primary"
                        startAdornment={
                            <InputAdornment position="start">
                                <Route sx={{ color: GREEN }} />
                            </InputAdornment>
                        }
                        sx={{ borderRadius: 3 }}
                    >
                        {travelRoute?.map((route) => (
                            <MenuItem key={route.tid} value={route.tid}>
                                {route.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Divider sx={{ my: 3 }} />

                {/* ② อัปโหลดรูปใหม่ */}
                <SectionTitle step={2} title="อัปโหลดรูปภาพอินโฟกราฟิก" />
                <Box
                    sx={{
                        border: `2px dashed ${BORDER}`,
                        borderRadius: 3,
                        bgcolor: LIGHT,
                        p: 3,
                        textAlign: "center",
                    }}
                >
                    <CloudUpload sx={{ fontSize: 48, color: GREEN }} />
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        เลือกไฟล์รูปอินโฟกราฟิกของเส้นทาง (เลือกได้หลายไฟล์)
                    </Typography>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<CloudUpload />}
                        sx={{ borderRadius: 3, color: GREEN, borderColor: GREEN, bgcolor: "white" }}
                    >
                        เลือกรูปอินโฟกราฟิกเส้นทาง
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            hidden
                            onChange={(e) => handleImageUpload(e, "info_route")}
                        />
                    </Button>
                </Box>

                {infoImages.length === 0 ? (
                    <Box sx={{ textAlign: "center", py: 3, color: "text.disabled" }}>
                        <InsertPhoto sx={{ fontSize: 40 }} />
                        <Typography variant="body2">ยังไม่ได้เลือกรูปภาพ</Typography>
                    </Box>
                ) : (
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        {infoImages.map((img, index) => (
                            <Grid item xs={6} sm={4} key={index}>
                                <Paper variant="outlined" sx={{ ...subCardSx, p: 1, position: "relative" }}>
                                    <Box
                                        component="img"
                                        src={img.preview}
                                        alt={`preview-${index}`}
                                        sx={{ width: "100%", height: 120, objectFit: "cover", borderRadius: 2, display: "block" }}
                                    />
                                    <Typography variant="caption" color="text.secondary" noWrap sx={{ display: "block", mt: 0.5 }}>
                                        {img.name}
                                    </Typography>
                                    <Tooltip title="ลบรูปนี้">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleRemoveImage(img.type, index)} // ✅ ส่ง type ด้วย
                                            sx={{ position: "absolute", top: 12, right: 12, bgcolor: "rgba(255,255,255,0.9)", color: "error.main", "&:hover": { bgcolor: "white" } }}
                                        >
                                            <Close fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                )}

                {/* Progress Bar */}
                {uploading && (
                    <Box sx={{ width: '100%', mt: 2 }}>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            sx={{ height: 8, borderRadius: 4, bgcolor: LIGHT, "& .MuiLinearProgress-bar": { bgcolor: GREEN } }}
                        />
                        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                            กำลังอัปโหลด... {Math.round(progress)}%
                        </Typography>
                    </Box>
                )}
            </AdminPage>
            <Snackbar
                open={errorSnackbar.open}
                autoHideDuration={3000}
                onClose={() => setErrorSnackbar({ open: false, message: "" })}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    // onClose={handleCloseSnackbar}
                    severity={errorSnackbar.severity}
                    sx={{
                        bgcolor:
                            errorSnackbar.severity === "success"
                                ? "#4CAF50" // สีเขียว
                                : errorSnackbar.severity === "error"
                                    ? "#f44336" // สีแดง
                                    : "#ff9800", // สีส้มสำหรับ warning
                        color: "white",
                    }}
                >
                    {/* <Alert
                    severity="error"
                    variant="filled"
                    sx={{ fontWeight: "bold" }}
                > */}
                    {errorSnackbar.message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            {/* Loading Overlay */}
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={initialLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {/* ฟอร์มหลักของคุณ */}
        </>
    )
}

export default MainEditImageInfographic